import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BEDistributedTransaction } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { DTAttribute } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DTAttribute';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { EnumDTPType } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MDAConstant } from '../../Base/MDAConstant';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { DataTypeManager } from '../../../MD/DataTypeManager';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointDistributedTransactionShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointDistributedTransactionShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_DistributedTransaction.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEDistributedTransaction, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.attributes, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION;
  }

  get distributedTransaction(): BEDistributedTransaction {
    return this.element() as BEDistributedTransaction;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加分布式事务属性
      case 'shape:addDTAttribute':
        element = this.addDTAttribute();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof DTAttribute) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addDTAttribute(): DTAttribute {
    const attribute = MDRepository.createDTAttribute(this.distributedTransaction);
    MDExtendService.setElementListSequence(this.distributedTransaction.attributes, true);
    this.model().compartments[0].push(attribute);
    return attribute;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.distributedTransaction.attributes.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.distributedTransaction.attributes.splice(this.distributedTransaction.attributes.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(distributedTransaction: BEDistributedTransaction, isCollapse = false): ShapeModel {
    const model = new ShapeModel(distributedTransaction, isCollapse);
    model.addCompartment(distributedTransaction.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointDistributedTransactionShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEDistributedTransaction();
    newElement.copyFrom(this.distributedTransaction, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.distributedTransactions.push(newElement);
    }

    this.distributedTransaction.attributes.forEach(item => {
      const attribute = new DTAttribute();
      attribute.copyFrom(item, false);
      MDExtendService.setCreateInfo(attribute);
      attribute.distributedTransaction_ID = newElement.id;
      newElement.attributes.push(attribute);
      elements.push(attribute);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): DTAttribute | null {
    let newElement: DTAttribute | null = null;
    if (element instanceof DTAttribute) {
      newElement = new DTAttribute();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.distributedTransaction_ID = this.distributedTransaction.id;
      this.distributedTransaction.attributes.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 分布式事务
   *    - 分布式协议类型目前只支持TCC
   * 2. 返回值
   *    - 数据类型为引用时，必须选择引用数据类型
   *    - 设置返回分页的时候，必须设置返回值是集合
   * 3. 属性
   *    - 属性必须填写名称
   *    - 属性必须填写显示名称
   *    - 属性数据类型为引用时，必须选择引用数据类型
   *    - 不能存在同名属性
  */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.distributedTransaction.designId;
    MDValidation.validateBaseElement(this.distributedTransaction, this.distributedTransaction.designId, true, errors);
    if (this.distributedTransaction.returnDataType === EnumDataType.Reference && !ValidateHelper.IsNotNullOrEmpty(this.distributedTransaction.returnReferenceType)) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `分布式事务 [${this.distributedTransaction.displayName}] 返回值数据类型为引用时，必须选择引用数据类型`));
    }
    if (this.distributedTransaction.returnIsPaged && !this.distributedTransaction.returnIsCollection) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `分布式事务 [${this.distributedTransaction.displayName}] 设置返回分页的时候，必须设置返回值是集合`));
    }
    if (this.distributedTransaction.protocolType !== EnumDTPType.TCC) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `分布式事务 [${this.distributedTransaction.displayName}] 目前只支持TCC协议`));
    }
    this.distributedTransaction.attributes.forEach(element => {
      MDValidation.validateBaseElement(element, containerDesignId, true, errors);
      if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `分布式事务 [${this.distributedTransaction.displayName}] 的属性 [${element.displayName}] 必须选择引用数据类型`));
      }
      if (this.distributedTransaction.attributes.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `分布式事务 [${this.distributedTransaction.displayName}] 不能存在同名属性 [${element.name}]`));
      }
    });
    return errors;
  }
}
